/**
 * Extracts the organization name from the current subdomain
 * @returns {string} The organization name in lowercase extracted from the subdomain
 */
export const getOrganizationFromSubdomain = () => {
    const hostname = window.location.hostname;
    
    // Extract subdomain (everything before the first dot)
    // For example: toroschushashiow.adswebapp.com -> toroschushashiow
    const parts = hostname.split('.');
    
    if (parts.length > 0) {
        const subdomain = parts[0];
        // Return lowercase subdomain - backend will handle case-insensitive matching
        return subdomain.toLowerCase();
    }
    
    // Fallback: return empty string or handle error
    return '';
};
